import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Surface stylesheets split out of index.css, imported in original source order
// so the global cascade is unchanged (selectors are non-hashed; same names).
import './apiDebug.css';
import './replay.css';
import './autoplay.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

